import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const reactivateMockWorker = (registration: ServiceWorkerRegistration) => {
  const serviceWorker = registration.active ?? navigator.serviceWorker.controller;

  serviceWorker?.postMessage('MOCK_ACTIVATE');
};

const keepMockWorkerActive = (registration: ServiceWorkerRegistration) => {
  const reactivate = () => {
    if (document.visibilityState === 'hidden') return;

    reactivateMockWorker(registration);
    void registration.update().catch(err => console.warn('[MSW] Failed to update mock service worker.', err));
  };

  const reactivateWhenVisible = () => {
    if (document.visibilityState === 'visible') {
      reactivate();
    }
  };

  window.addEventListener('focus', reactivate);
  window.addEventListener('online', reactivate);
  window.addEventListener('pageshow', reactivate);
  document.addEventListener('visibilitychange', reactivateWhenVisible);
  navigator.serviceWorker.addEventListener('controllerchange', reactivate);

  window.setInterval(reactivate, 60_000);
  reactivate();
};

const prepareApp = async () => {
  if (environment.useMocks) {
    const { worker } = await import('./app/core/mocks/browser');

    const swUrl = new URL('mockServiceWorker.js', document.baseURI).href;

    const registration = await worker.start({
      serviceWorker: {
        url: swUrl,
      },
      onUnhandledFrame: 'bypass',
    });

    if (registration) {
      keepMockWorkerActive(registration);
    }
  }

  return bootstrapApplication(App, appConfig);
};

void prepareApp().catch(err => console.error(err));
